import { useState } from "react";
import { motion } from "framer-motion";
import { FaCalendarAlt } from "react-icons/fa";
import { db } from "../lib/firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { useTranslation } from "react-i18next";

const BookAppointment = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await addDoc(collection(db, "appointments"), {
        ...formData,
        timestamp: serverTimestamp(),
      });

      alert(t("appointment.success"));
      setFormData({ name: "", phone: "", message: "" });
      setIsOpen(false);
    } catch (error) {
      console.error("Error submitting appointment:", error);
      alert(t("appointment.error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed bottom-6 right-6 flex flex-col items-end z-50">
      {!isOpen && (
        <button
          className="bg-red-600 text-white p-4 rounded-full shadow-lg flex items-center gap-2 hover:bg-blue-700 transition-all"
          onClick={() => setIsOpen(true)}
        >
          <FaCalendarAlt size={20} />
          <span>{t("appointment.bookButton")}</span>
        </button>
      )}

      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          className="bg-white shadow-2xl rounded-lg p-4 w-72"
        >
          <div className="flex justify-between items-center border-b pb-2 mb-3">
            <h2 className="text-lg font-bold text-gray-700">
              {t("appointment.title")}
            </h2>
            <button
              onClick={() => setIsOpen(false)}
              className="text-gray-500 hover:text-red-500"
            >
              &times;
            </button>
          </div>

          <form onSubmit={handleSubmit} className="flex flex-col gap-3">
            <input
              type="text"
              name="name"
              placeholder={t("appointment.name")}
              value={formData.name}
              onChange={handleChange}
              required
              className="border rounded-md p-2 w-full focus:ring focus:ring-blue-300"
            />
            <input
              type="tel"
              name="phone"
              placeholder={t("appointment.phone")}
              value={formData.phone}
              onChange={handleChange}
              required
              className="border rounded-md p-2 w-full focus:ring focus:ring-blue-300"
            />
            <textarea
              name="message"
              placeholder={t("appointment.message")}
              value={formData.message}
              onChange={handleChange}
              className="border rounded-md p-2 w-full focus:ring focus:ring-blue-300"
            ></textarea>
            <button
              type="submit"
              className="bg-red-600 text-white p-2 rounded-md shadow-md hover:bg-blue-700 transition-all"
              disabled={loading}
            >
              {loading ? t("appointment.submitting") : t("appointment.submit")}
            </button>
          </form>
        </motion.div>
      )}
    </div>
  );
};

export default BookAppointment;
